import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: localStorage.getItem("@user_Data")
    ? JSON.parse(localStorage.getItem("@user_Data"))
    : null,
  isLogin: localStorage.getItem("@storage_Token") ? true : false,
  token: "",
  error: false,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser(state, action) {
      state.data = action.payload;
      // state.isLogin = true;
      // state.error = false;
    },
    setLogin(state, action) {
      state.isLogin = true;
      state.token = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    removeUser(state) {
      state.data = null;
      state.isLogin = false;
      localStorage.clear();
    },
  },
});

export const { setUser, setLogin, setError, removeUser } = userSlice.actions;

export default userSlice.reducer;
